import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {
    filterDropdown_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";

declare var ko: any;

export class quizPickerView_template extends vnTemplate {
    protected parent: any;
    public brandSingleFilter: filterDropdown_template;
    protected insertDropdownDocumentClickHandler: ((event: MouseEvent) => void) | null = null;

    protected getTemplateHtml(): string {
        return /* html */ `
      <div class="w-picker-form form-edit" id="quiz-picker-view" data-bind="css: { 'is-visible': isShown }">
        <div class="picker-form">
          <div class="form-header w-justify">
            <div class="w-left"></div>
            <div class="w-center">
              <div class="section-title">
                <h3 class="section-title icon i-poll">Quiz</h3>
              </div>
            </div>
            <div class="w-right">
              <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
            </div>
          </div>

          <div class="quiz-picker-scroll">
          <div class="w-form-body">
            <div class="form-body full-width quiz-picker-actions">
              <div class="body-header w-justify">
                <div class="w-left">
                  <button type="button" class="btn icon i-edit" data-bind="event: { click: onClickEdit }">Edit Quiz Source</button>
                </div>
                <div class="w-right">
                  <div class="insert-dropdown" data-bind="css: { 'is-open': isInsertDropdownOpen }">
                    <button class="btn-icon insert-dropdown-toggle i-dropdown-simple icon i-ins" type="button" data-bind="event: { click: onClickToggleInsertDropdown }"><span>Insert</span></button>
                    <div class="insert-dropdown-list">
                      <button class="btn-icon icon i-ins" type="button" data-bind="event: { click: onClickInsert.bind($data, true) }" title="Insert with Dynamic Placement"><span>Dynamic Using Sentinel Avg. Scroll Depth %</span></button>
                      <button class="btn-icon icon i-ins" type="button" data-bind="event: { click: onClickInsert.bind($data, false) }" title="Insert without Dynamic Placement"><span>Static Placement</span></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="w-form-body quiz-picker-info-section">
            <div class="form-body">
              <div class="form-group quiz-picker-info-panel">
                <div class="quiz-picker-info-row quiz-picker-info-row--title-brands">
                  <div class="quiz-picker-info-field quiz-picker-info-field--title">
                    <dl class="double-list margin column">
                      <dt><span>Title</span></dt>
                      <dd class="no-cap"><span data-bind="text: title"></span></dd>
                    </dl>
                  </div>
                  <div class="quiz-picker-info-field quiz-picker-info-field--brands">
                    <dl class="double-list margin column">
                      <dt><span>Brands</span></dt>
                      <dd class="no-cap"><span data-bind="text: attachedBrands() || 'None'"></span></dd>
                    </dl>
                  </div>
                </div>

                <div class="quiz-picker-info-divider" data-bind="visible: sourceArticle"></div>

                <div class="quiz-picker-info-row" data-bind="visible: sourceArticle">
                  <div class="quiz-picker-info-field quiz-picker-info-field--full">
                    <dl class="double-list margin column">
                      <dt><span>Source Article</span></dt>
                      <dd class="no-cap"><span data-bind="text: sourceArticleDisplay() || 'None'"></span></dd>
                    </dl>
                  </div>
                </div>

                <div class="quiz-picker-info-divider"></div>

                <div class="quiz-picker-info-row quiz-picker-info-row--meta">
                  <div class="quiz-picker-info-field">
                    <dl class="double-list margin column">
                      <dt><span>ID</span></dt>
                      <dd class="no-cap"><span data-bind="text: id() || 'New'"></span></dd>
                    </dl>
                  </div>
                  <div class="quiz-picker-info-field">
                    <dl class="double-list margin column">
                      <dt><span>Number of Questions</span></dt>
                      <dd class="no-cap"><span data-bind="text: numberOfQuestions"></span></dd>
                    </dl>
                  </div>
                  <div class="quiz-picker-info-field">
                    <dl class="double-list margin column">
                      <dt><span>Date Created</span></dt>
                      <dd class="no-cap"><span data-bind="text: dateCreated() || 'Not Selected'"></span></dd>
                    </dl>
                  </div>
                  <div class="quiz-picker-info-field">
                    <dl class="double-list margin column">
                      <dt><span>Date Updated</span></dt>
                      <dd class="no-cap"><span data-bind="text: dateUpdated() || 'Not Selected'"></span></dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="w-form-body quiz-picker-stats-section">
            <div class="form-body full-width">
              <div class="form-group quiz-picker-section-heading">
                <label class="form-label quiz-picker-section-heading__label">Stats</label>
              </div>
            </div>
            <div class="form-body full-width quiz-picker-stats-panel">
              <div class="form-group quiz-picker-stats-filter-group">
                ${this.brandSingleFilter.getHtmlBuild()}
              </div>
              <div class="form-group quiz-picker-stats-data">
                <dl class="double-list margin">
                  <dt><span>Number of Respondents</span></dt>
                  <dd><span data-bind="text: selectedStats().numberOfRespondents"></span></dd>
                  <dt><span>Average Score</span></dt>
                  <dd><span data-bind="text: selectedStats().averageScore"></span></dd>
                </dl>
              </div>
            </div>
          </div>

          <div class="w-form-body quiz-picker-questions-section">
            <div class="form-body full-width">
              <div class="form-group quiz-picker-section-heading">
                <label class="form-label quiz-picker-section-heading__label">Questions</label>
              </div>
            </div>
          </div>

          <div class="w-form-body quiz-picker-empty-questions" data-bind="visible: questions().length == 0">
            <div class="form-body full-width">
              <div class="form-group">
                <p class="form-text">This quiz has no questions.</p>
              </div>
            </div>
          </div>

          <div class="w-form-body quiz-questions-list">
          <div data-bind="foreach: questions">
            <div class="quiz-question-block">
              <strong class="quiz-question-block__index" data-bind="text: 'Question ' + ($index() + 1)"></strong>

              <div class="quiz-question-block__body">
                <div class="quiz-question-field-row">
                  <label class="form-label">Question</label>
                  <span class="quiz-question-value" data-bind="text: question"></span>
                </div>

                <div class="quiz-question-field-row quiz-question-field-row--split">
                  <div class="quiz-question-field">
                    <label class="form-label">Difficulty</label>
                    <span class="quiz-question-value" data-bind="text: difficulty"></span>
                  </div>
                  <div class="quiz-question-field">
                    <label class="form-label">Basis</label>
                    <span class="quiz-question-value" data-bind="text: basis"></span>
                  </div>
                </div>

                <div class="quiz-question-field-row">
                  <label class="form-label">Rationale</label>
                  <span class="quiz-question-value" data-bind="text: rationale"></span>
                </div>

                <div class="quiz-options">
                  <label class="form-label">Answer Options</label>
                  <div data-bind="foreach: options">
                    <div class="quiz-option-row" data-bind="css: { 'quiz-option-row--correct': isCorrect }">
                      <span class="quiz-question-value" data-bind="text: text"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          </div>
        </div>
      </div>
    `;
    }

    protected buildViewModel(): any {
        const self = this;
        return {
            isShown: ko.observable(false),
            quiz: ko.observable(null),
            id: ko.observable(null),
            title: ko.observable(""),
            attachedBrands: ko.observable(""),
            idSourceArticle: ko.observable(null),
            idSourceArticleBrand: ko.observable(null),
            numberOfQuestions: ko.observable(0),
            dateCreated: ko.observable(""),
            dateUpdated: ko.observable(""),
            sourceArticle: ko.observable(null),
            sourceArticleDisplay: ko.observable(""),
            questions: ko.observableArray([]),
            stats: ko.observable({network: {numberOfRespondents: 0, averageScore: 0}, brands: {}}),
            selectedStats: ko.observable({numberOfRespondents: 0, averageScore: 0}),
            brandReferences: ko.observableArray([]),
            activeBrandIds: ko.observableArray([]),
            isQuizDynamicPlacementOnByDefault: ko.observable(false),
            isQuizDynamicPlacement: ko.observable(false),
            isInsertDropdownOpen: ko.observable(false),
            onClickCancel: function () {
                self.hide();
            },
            onClickInsert: function (isQuizDynamicPlacement) {
                self.onClickInsert(isQuizDynamicPlacement);
            },
            onClickToggleInsertDropdown: function (data, event) {
                event.stopPropagation();
                self.toggleInsertDropdown();
            },
            onClickEdit: function () {
                self.onClickEdit();
            },
        };
    }

    protected getTemplateName(): string {
        return "quizPickerView-template";
    }

    protected initPartial(): void {
        this.brandSingleFilter = new filterDropdown_template("quizPickerViewBrandSingleFilter", this.getTemplateViewModel(), this);
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    public setParent(parent): this {
        this.parent = parent;
        return this;
    }

    public setQuiz(quiz): void {
        this.setQuizData(quiz);
        this.setId(quiz.id || null);
        this.setTitle(quiz.title || "");
        this.setIdSourceArticle(quiz.idSourceArticle || null);
        this.setIdSourceArticleBrand(quiz.idSourceArticleBrand || null);
        this.setNumberOfQuestions(quiz.numberOfQuestions || (quiz.quiz || []).length || 0);
        this.setDateCreated(quiz.dateCreated || "");
        this.setDateUpdated(quiz.dateUpdated || "");
        this.setSourceArticle(quiz.article || null);
        this.setQuestions(this.formatQuestions(quiz.quiz || []));
        this.setBrandResults(quiz.stats || {}, quiz.brands || []);
    }

    public setQuizData(quiz): void {
        this.getTemplateViewModel().quiz(quiz);
    }

    public getQuizData() {
        return this.getTemplateViewModel().quiz();
    }

    public setId(id): void {
        this.getTemplateViewModel().id(id);
    }

    public getId() {
        return this.getTemplateViewModel().id();
    }

    public setTitle(title): void {
        this.getTemplateViewModel().title(title);
    }

    public getTitle() {
        return this.getTemplateViewModel().title();
    }

    public setIdSourceArticle(idSourceArticle): void {
        this.getTemplateViewModel().idSourceArticle(idSourceArticle);
    }

    public getIdSourceArticle() {
        return this.getTemplateViewModel().idSourceArticle();
    }

    public setIdSourceArticleBrand(idSourceArticleBrand): void {
        this.getTemplateViewModel().idSourceArticleBrand(idSourceArticleBrand);
    }

    public setNumberOfQuestions(numberOfQuestions): void {
        this.getTemplateViewModel().numberOfQuestions(numberOfQuestions);
    }

    public getNumberOfQuestions() {
        return this.getTemplateViewModel().numberOfQuestions();
    }

    public setDateCreated(dateCreated): void {
        this.getTemplateViewModel().dateCreated(dateCreated);
    }

    public getDateCreated() {
        return this.getTemplateViewModel().dateCreated();
    }

    public setDateUpdated(dateUpdated): void {
        this.getTemplateViewModel().dateUpdated(dateUpdated);
    }

    public getDateUpdated() {
        return this.getTemplateViewModel().dateUpdated();
    }

    public setSourceArticle(sourceArticle): void {
        this.getTemplateViewModel().sourceArticle(sourceArticle);
        this.refreshSourceArticleDisplay();
    }

    public getSourceArticle() {
        return this.getTemplateViewModel().sourceArticle();
    }

    protected refreshSourceArticleDisplay(): void {
        const sourceArticle = this.getSourceArticle();
        if (sourceArticle && sourceArticle.id) {
            this.getTemplateViewModel().sourceArticleDisplay(this.getSourceArticleDisplayTitle(sourceArticle));
            return;
        }

        const idSourceArticle = this.getIdSourceArticle();
        this.getTemplateViewModel().sourceArticleDisplay(idSourceArticle ? this.getSourceArticleDisplayTitle({
            id: idSourceArticle,
            title: "Article #" + idSourceArticle,
        }) : "");
    }

    protected getSourceArticleDisplayTitle(article): string {
        if (!article || !article.id) {
            return "";
        }

        const title = article.title || "";
        const id = article.id || "";
        const brandName = this.getSourceArticleBrandName(article);

        return `${title} (${id} - ${brandName})`;
    }

    protected getSourceArticleBrandName(article = null): string {
        if (article) {
            const articleBrandName = article.brandName || article.brandShortName || article.brand || article.shortName;
            if (articleBrandName) {
                return articleBrandName;
            }
        }

        const sourceArticleBrandId = this.getTemplateViewModel().idSourceArticleBrand();
        const brand = (this.getBrandReferences() || []).find((brandReference) => {
            return Number(brandReference.id) === Number(sourceArticleBrandId);
        });

        return brand ? (brand.name || brand.shortName || "") : "";
    }

    public setQuestions(questions): void {
        this.getTemplateViewModel().questions(questions);
    }

    public getQuestions() {
        return this.getTemplateViewModel().questions();
    }

    public setReferences(references): void {
        this.setBrandReferences(references.brands || []);
    }

    public setBrandReferences(brandReferences): void {
        const lightReferences = [];
        for (const brandReference of (brandReferences || [])) {
            lightReferences.push({
                id: brandReference.id,
                name: brandReference.name,
                shortName: brandReference.shortName,
            });
        }

        this.getTemplateViewModel().brandReferences(lightReferences);
        this.refreshSourceArticleDisplay();
        const activeBrandIds = this.getActiveBrandIds();
        if (activeBrandIds.length > 0) {
            this.setBrandResults(this.getStats(), activeBrandIds);
        }
    }

    public getBrandReferences() {
        return this.getTemplateViewModel().brandReferences();
    }

    public setBrandResults(stats, activeBrandIds): void {
        const references = this.getBrandReferences();
        const brandReferences = [{id: -1, name: "Network", shortName: "Network"}];
        const brandNames = [];
        const normalizedActiveBrandIds = (activeBrandIds || []).map((brandId) => Number(brandId));

        for (const reference of references) {
            if (normalizedActiveBrandIds.indexOf(Number(reference.id)) !== -1) {
                brandReferences.push(reference);
                brandNames.push(reference.shortName || reference.name);
            }
        }

        this.setActiveBrandIds(normalizedActiveBrandIds);
        this.setAttachedBrands(brandNames.join(", "));
        this.brandSingleFilter.setOptions(brandReferences);
        this.brandSingleFilter.setSelectedOption(-1);
        this.setStats(stats);
    }

    public filterDropdownOnChange(idElement): void {
        if (idElement === "quizPickerViewBrandSingleFilter") {
            this.handleBrandChange();
        }
    }

    public handleBrandChange(): void {
        const selectedBrand = this.brandSingleFilter.getSelectedOption();
        const stats = this.getStats();
        if (selectedBrand && selectedBrand.id > 0) {
            const brandStats = stats.brands || {};
            this.setSelectedStats(brandStats[selectedBrand.id] || {numberOfRespondents: 0, averageScore: 0});
            return;
        }

        this.setSelectedStats(stats.network || {numberOfRespondents: 0, averageScore: 0});
    }

    public setStats(stats): void {
        const fallbackStats = {network: {numberOfRespondents: 0, averageScore: 0}, brands: {}};
        this.getTemplateViewModel().stats(stats || fallbackStats);
        this.setSelectedStats((stats || fallbackStats).network || fallbackStats.network);
    }

    public getStats() {
        return this.getTemplateViewModel().stats();
    }

    public setAttachedBrands(attachedBrands): void {
        this.getTemplateViewModel().attachedBrands(attachedBrands);
    }

    public getAttachedBrands() {
        return this.getTemplateViewModel().attachedBrands();
    }

    public setSelectedStats(stats): void {
        this.getTemplateViewModel().selectedStats(stats || {numberOfRespondents: 0, averageScore: 0});
    }

    public getSelectedStats() {
        return this.getTemplateViewModel().selectedStats();
    }

    public setActiveBrandIds(activeBrandIds): void {
        this.getTemplateViewModel().activeBrandIds(activeBrandIds || []);
    }

    public getActiveBrandIds() {
        return this.getTemplateViewModel().activeBrandIds();
    }

    public setIsQuizDynamicPlacementOnByDefault(isQuizDynamicPlacementOnByDefault): void {
        this.getTemplateViewModel().isQuizDynamicPlacementOnByDefault(!!isQuizDynamicPlacementOnByDefault);
    }

    public setIsQuizDynamicPlacement(isQuizDynamicPlacement): void {
        this.getTemplateViewModel().isQuizDynamicPlacement(!!isQuizDynamicPlacement);
    }

    protected formatQuestions(questions): Array<any> {
        return (questions || []).map((question) => {
            const options = question.options || [];
            const answer = question.answer || "";
            const correctOptionIndex = typeof question.correctOptionIndex !== "undefined" ? question.correctOptionIndex : null;

            return {
                question: question.question || "",
                difficulty: question.difficulty || "",
                basis: question.basis || "",
                rationale: question.rationale || "",
                answer: answer,
                options: options.map((option, index) => {
                    const text = option.text || option.option || option.choiceText || "";
                    return {
                        text: text,
                        isCorrect: option.isCorrect === true || option.isCorrect === "on" || correctOptionIndex === index || (!!answer && answer === text),
                    };
                }),
            };
        });
    }

    public show(): void {
        this.getTemplateViewModel().isShown(true);
    }

    public hide(): void {
        this.closeInsertDropdown();
        this.getTemplateViewModel().isShown(false);
    }

    public showLoading(): void {
        const form = document.getElementById("quiz-picker-view");
        form && form.classList.add("loading");
    }

    public hideLoading(): void {
        const form = document.getElementById("quiz-picker-view");
        form && form.classList.remove("loading");
    }

    protected onClickInsert(isQuizDynamicPlacement): void {
        const quiz = this.getQuizData();
        if (!quiz) {
            return;
        }

        this.closeInsertDropdown();
        this.setIsQuizDynamicPlacement(isQuizDynamicPlacement);
        this.parent.insertQuiz(quiz, isQuizDynamicPlacement);
    }

    protected toggleInsertDropdown(): void {
        const willOpen = !this.getTemplateViewModel().isInsertDropdownOpen();
        this.getTemplateViewModel().isInsertDropdownOpen(willOpen);
        if (willOpen) {
            this.bindInsertDropdownDocumentClick();
        } else {
            this.unbindInsertDropdownDocumentClick();
        }
    }

    protected bindInsertDropdownDocumentClick(): void {
        this.unbindInsertDropdownDocumentClick();
        this.insertDropdownDocumentClickHandler = (event: MouseEvent) => {
            const target = event.target as Element | null;
            if (!target || !target.closest(".insert-dropdown")) {
                this.closeInsertDropdown();
            }
        };
        window.setTimeout(() => {
            if (this.getTemplateViewModel().isInsertDropdownOpen() && this.insertDropdownDocumentClickHandler) {
                document.addEventListener("click", this.insertDropdownDocumentClickHandler);
            }
        }, 0);
    }

    protected unbindInsertDropdownDocumentClick(): void {
        if (this.insertDropdownDocumentClickHandler) {
            document.removeEventListener("click", this.insertDropdownDocumentClickHandler);
            this.insertDropdownDocumentClickHandler = null;
        }
    }

    protected closeInsertDropdown(): void {
        this.getTemplateViewModel().isInsertDropdownOpen(false);
        this.unbindInsertDropdownDocumentClick();
    }

    protected onClickEdit(): void {
        const quiz = this.getQuizData();
        if (!quiz) {
            return;
        }

        this.parent.editQuiz(quiz);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/quizPickerView_template.ts